import React from 'react';
import {
  connect,
  Provider,
  useSelector,
  useDispatch,
  useStore,
} from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import storage from 'redux-persist/lib/storage';
import { stopSubmit, reset, change, startSubmit } from 'redux-form';

import store, { persistor } from 'store/store';
import { authSelectors, authActions } from 'store/modules/auth/auth';
import {
  projectSelectors,
  projectActions,
} from 'store/modules/project/project';
import {
  assistantSelectors,
  assistantActions,
} from 'store/modules/assistant/assistant';
import { parseErrors } from 'components/Forms/utils';

import {
  organizationsActions,
  organizationsSelectors,
} from 'store/modules/organizations/organizations';

import { intlActions, intlSelectors } from 'store/modules/intl/intl';

import projects from 'store/modules/projects';
import products from 'store/modules/products';
import briefings from 'store/modules/briefings';
import workbenches from 'store/modules/workbenches';
import reports from 'store/modules/reports';
import ui from 'store/modules/ui';
import assets from 'store/modules/assets';

interface StoreProviderProps {
  children: React.ReactNode;
}

const StoreProvider = ({ children }: StoreProviderProps) => (
  <Provider store={store}>
    <PersistGate persistor={persistor}>{children}</PersistGate>
  </Provider>
);

export default {
  storage,
  connect,
  useSelector,
  useDispatch,
  useStore,
  Provider: StoreProvider,
  actions: {
    projectActions,
    organizationsActions,
    authActions,
    // projectsActions,
    assistantActions,
    intlActions,
    projects: projects.actions,
    products: products.actions,
    briefings: briefings.actions,
    workbenches: workbenches.actions,
    reports: reports.actions,
    ui: ui.actions,
    assets: assets.actions,
    forms: {
      submitErrors: (reduxFormName: string, errors: { [key: string]: [] }) =>
        stopSubmit(reduxFormName, parseErrors(errors)),
      reset,
      change,
      stopSubmit,
      startSubmit,
    },
  },
  selectors: {
    authSelectors,
    // projectsSelectors,
    assistantSelectors,
    organizationsSelectors,
    intlSelectors,
    projectSelectors,
    projects: projects.selectors,
    products: products.selectors,
    briefings: briefings.selectors,
    workbenches: workbenches.selectors,
    reports: reports.selectors,
    ui: ui.selectors,
    assets: assets.selectors,
  },
};
